import React, { useContext } from 'react';
import { EncoreContext, encoreContextKeyword, encoreContextStatus, getStatus } from "../../../contexts/EncoreContext";
import { Experimental__IconX } from "../../Experimental__Icon/icons/Experimental__IconX";
import { Icon } from "../";
export function IconX(props) {
  var config = useContext(EncoreContext);
  var status = getStatus(encoreContextKeyword.icon, config);

  if (status === encoreContextStatus.next) {
    return /*#__PURE__*/React.createElement(Experimental__IconX, props);
  }

  return /*#__PURE__*/React.createElement(Icon, Object.assign({}, props, {
    dangerouslySetInnerHTML: {
      __html: "<path d=\"M4.93 4.93l14.14 14.14m-14.14 0L19.07 4.93\" fill=\"none\" stroke=\"#181818\"/>"
    }
  }));
}
export default IconX;